import { useEffect, useRef } from 'react';

/** Infinite-scroll sentinel: calls `onLoadMore` when it scrolls into view (with a
 *  200px pre-load margin) and shows a spinner while the next page loads. Renders
 *  nothing once there's nothing more to load. */
export function LoadMore({
  hasMore,
  loading,
  onLoadMore,
}: {
  hasMore: boolean;
  loading: boolean;
  onLoadMore: () => void;
}) {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!hasMore || loading) return;
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver(
      (entries) => {
        if (entries[0]?.isIntersecting) onLoadMore();
      },
      { rootMargin: '200px' },
    );
    io.observe(el);
    return () => io.disconnect();
  }, [hasMore, loading, onLoadMore]);

  if (!hasMore && !loading) return null;
  return (
    <div ref={ref} className="flex justify-center py-4">
      {loading && <span className="size-6 animate-spin rounded-full border-[3px] border-border border-t-accent" />}
    </div>
  );
}
